import { render } from "./Wallet.vue?vue&type=template&id=7103cd3a&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"

import "./Wallet.vue?vue&type=style&index=0&id=7103cd3a&lang=css"
import "./Wallet.vue?vue&type=style&index=1&id=7103cd3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7103cd3a"]])

export default __exports__